define('commons/tooltip',['jquery', 'jquery.ui'], function($) {

    $(".help-tip-icon").each(function(index, el) {
        el = $(el);
        var target = el.data("tip-target-id");
        if (target) {
            var content = $("#" + target);
            content.show();
            $(el).tooltip({
                items: el,
                tooltipClass: "help-ui-tooltip",
                content: function(fn) {
                    return content;
                }
            });
            content.remove();
        }
    });

});
